import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import InputField from "components/fields/InputField";
import Modal from "components/modal";
import Spinner from "components/spinner";
import { showToast } from "components/toast";
import { CONTAINER_STATUS } from "constants";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { resetContainerNoData } from "store/containerSlice";
import { generatorContainerNo } from "store/containerSlice";
import { addContainer } from "store/containerSlice";

function AddContainer({ refreshList }) {
  const dispatch = useDispatch();
  const {
    createLoading,
    containerNoError,
    containerNoData,
    containerNoLoading,
    containerStatusData,
  } = useSelector((state) => state.containers);

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => {
    reset();
    setIsOpen(false);
    dispatch(resetContainerNoData());
  };
  useEffect(() => {
    const fetchData = async () => {
      await dispatch(generatorContainerNo());
    };

    if (isOpen) {
      fetchData();
    }
  }, [isOpen]);

  const createdStatusId = useMemo(() => {
    return (
      containerStatusData?.find(
        (item) => item.enumVal === CONTAINER_STATUS.CREATED
      )?._id || null
    );
  }, [containerStatusData]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      departurePort: "",
      arrivalPort: "",
      eta: "",
      departureTimeDate: "",
    },
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    if (!containerNoData) {
      console.error("Container number is not available!");
      showToast.error("Container number is not available!");
      return;
    }
    if (!createdStatusId) {
      console.error("Created status ID not available!");
      showToast.error("Created status ID not available!.");
      return;
    }
    try {
      const payload = {
        ...data,
        departureTimeDate: data.departureTimeDate
          ? new Date(data.departureTimeDate).toISOString()
          : null,
        eta: data.eta ? new Date(data.eta).toISOString() : null,
        containerNo: containerNoData,
        status: createdStatusId,
      };

      const response = await dispatch(addContainer(payload));

      if (
        response?.payload?.statuscode === 201 ||
        response?.payload?.statuscode === 200
      ) {
        refreshList?.();
        closeModal();
        reset();
      } else {
        console.error(
          "Create failed:",
          response?.payload?.msg || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Create failed:", error);
    }
  };

  return (
    <div>
      <Button onClick={openModal}>Add Container</Button>

      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-md">
        <h2 className="flex items-center border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Add Container{" #"}
          {containerNoLoading ? (
            <Spinner />
          ) : containerNoError ? (
            <div className="flex items-center gap-2 text-red-500">
              <RiErrorWarningFill className="h-4 w-4" />
            </div>
          ) : (
            containerNoData
          )}
        </h2>

        <div className="mt-5 w-full max-w-4xl flex-col items-center lg:pl-0">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="mx-auto grid w-full grid-cols-1 gap-4"
            noValidate
          >
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              <InputField
                id="departurePort"
                variant="auth"
                label="Departure Port*"
                placeholder="Enter departure port"
                type="text"
                error={errors.departurePort}
                {...register("departurePort", {
                  required: "Departure Port is required",
                })}
              />

              <InputField
                id="arrivalPort"
                variant="auth"
                label="Arrival Port*"
                placeholder="Enter arrival port"
                type="text"
                error={errors.arrivalPort}
                {...register("arrivalPort", {
                  required: "Arrival Port is required",
                })}
              />
              <InputField
                id="departureTimeDate"
                variant="auth"
                label="Departure Time & Date*"
                placeholder="Select departure time & date"
                type="datetime-local"
                error={errors.departureTimeDate}
                {...register("departureTimeDate", {
                  required: "Departure Time & Date is required",
                })}
              />

              <InputField
                id="eta"
                variant="auth"
                label="ETA*"
                placeholder="Select ETA"
                type="datetime-local"
                error={errors.eta}
                {...register("eta", { required: "ETA is required" })}
              />
            </div>

            <div className="my-4 flex items-center justify-end gap-2 pt-2">
              <Button type="button" variant="outline" onClick={closeModal}>
                Cancel
              </Button>

              <LoaderButton
                type="submit"
                isLoading={createLoading}
                disabled={!!containerNoError}
              >
                Add Container
              </LoaderButton>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default AddContainer;
